import { render, staticRenderFns } from "./bimTextH4.vue?vue&type=template&id=5505cf98&scoped=true&lang=html&"
import script from "./bimTextH4.vue?vue&type=script&lang=js&"
export * from "./bimTextH4.vue?vue&type=script&lang=js&"
import style0 from "./bimTextH4.vue?vue&type=style&index=0&id=5505cf98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5505cf98",
  null
  
)

export default component.exports